export function getCsrfToken(): string {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]*)/);
  return match ? match[1] : '';
}

export function csrfHeaders(): Record<string, string> {
  return { 'x-csrf-token': getCsrfToken() };
}
